/**
 * Create the store with dynamic reducers
 */

import { StoreEnhancer, configureStore } from '@reduxjs/toolkit';
import { createInjectorsEnhancer, forceReducerReload } from 'redux-injectors';
import createSagaMiddleware from 'redux-saga';

import { createReducer } from './reducers';

export function configureAppStore() {
  const reduxSagaMonitorOptions = {};
  const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);
  const { run: runSaga } = sagaMiddleware;

  // Create the store with saga middleware
  // The only middleware (redux-middleware), we are currently using in our app (so far)
  // Saga intercepts the dispatch actions and let us handle side-effects including calling the back-end api to fetch/update data which
  // then notified to reducer to update it's local store.

  const middlewares = [sagaMiddleware];

  const enhancers = [
    createInjectorsEnhancer({
      createReducer,
      runSaga,
    }),
  ] as StoreEnhancer[];

  // Middlewares are third party libraries which intercept each redux action dispatched to the redux store and then... do stuff.
  // For example, if you install the redux-logger middleware
  // it will listen to all the actions being dispatched to the store and print previous and next state in the browser console.
  // It's helpful to track what happens in your app.
  const store = configureStore({
    reducer: createReducer(),
    middleware: gDM =>
      gDM({
        thunk: false,
        serializableCheck: false,
      }).concat(middlewares),
    devTools: process.env.NODE_ENV !== 'production',
    enhancers: gDE => gDE().concat(enhancers),
  });

  // Make reducers hot reloadable with Vite HMR
  if (import.meta.hot) {
    import.meta.hot.accept('./reducers', () => {
      forceReducerReload(store);
    });
  }

  return store;
}
